<template>
    <div class="HomePage">
        <div class="Home">
            <el-carousel class="carousel" indicator-position="none" arrow="never" :interval='8000' autoplay>
                <el-carousel-item v-for="slider of sliders" :key="slider">
                    <div :style="{ 'background-image': 'url(' + slider + ')' }" class="slider-img"></div>
                </el-carousel-item>
            </el-carousel>
            <div class="Home__TaglineContainer">
                <h1 class="Home__Tagline Home__TaglineH1" :style="{'font-family': language == 'english' ? english : japanese}">{{'Find your new home' | language}} </h1>
                <p class="Home__Tagline Home__TaglineP">{{'Making your Japan home search easier.' | language}}</p>
                <SearchBar/>
                <SearchAdvancedNav style="color:white !important;" />
            </div>
        </div>

        <div id="rental-procedure">
            <div class="container">
                <h1>{{'Rental Procedure' | language}}</h1>

                <div class="row">
                    <div class="col-md-4 col-sm-6 col-xs-12 col">
                        <div class="col-cell">
                            <img src="../../../assets/images/home-icons/Home_Inquiry_Logo.png" alt="Inquiry">
                            <h3><span>1</span> {{'Inquiry' | language}}</h3>
                            <p>{{'Inquiry_content' | language}}</p>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12 col">
                        <div class="col-cell">
                            <img src="../../../assets/images/home-icons/Consultation_Logo.png" alt="Consultation">
                            <h3><span>2</span> {{'Consultation' | language}}</h3>
                            <p>{{'Consultation_content' | language}}</p>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12 col">
                        <div class="col-cell">
                            <img src="../../../assets/images/home-icons/Home_Finding_Logo.png" alt="Viewing">
                            <h3><span>3</span> {{'Viewing' | language}}</h3>
                            <p>{{'Viewing_content' | language}}</p>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12 col">
                        <div class="col-cell">
                            <img src="../../../assets/images/home-icons/Application_Logo.png" alt="Application">
                            <h3><span>4</span> {{'Application' | language}}</h3>
                            <p>{{'Application_content' | language}}</p>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12 col">
                        <div class="col-cell">
                            <img src="../../../assets/images/home-icons/Lease_Signing_Logo.png" alt="Lease Signing">
                            <h3><span>5</span> {{'Lease Signing' | language}}</h3>
                            <p>{{'Lease_content' | language}}</p>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12 col">
                        <div class="col-cell">
                            <img src="../../../assets/images/home-icons/Move-In_Logo.png" alt="Move In">
                            <h3><span>6</span> {{'Move In' | language}}</h3>
                            <p>{{'MoveIn_content' | language}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div id="assess-section">
                <div class="container">
                    <h1>{{'Personalize Your Search' | language}}</h1>
                    <p>{{'WE assess your needs and send properties right for YOU, just for YOU' | language}}</p>
                    <el-button type="default">
                        <router-link to="/needs-assessment">{{'Needs Assessment' | language}}</router-link>
                    </el-button>
                </div>
            </div>

            <div id="video-section">
                <div class="container">
                    <div class="heading">
                        <a href="http://japan-mobility.com/" target="_blank" v-if="language === 'english'"><h1>Making it easier to<br><b>Relocate To Japan</b></h1></a>
                        <a href="http://japan-mobility.com/" target="_blank" v-else><h1>日本へのお引越しをスムーズに</h1></a>
                        <div><a href="http://japan-mobility.com/" target="_blank"><img src="@/assets/images/japan-mobility-logo.png" alt="Japan Mobility"></a></div>
                    </div>

                    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/327220039?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
                </div>
            </div>

            <div id="hot-properties">
                <div class="container">
                    <h1><i class="fas fa-fire"></i>{{'Hot Properties' | language}}</h1>
                    <carousel
                        :perPageCustom="perPage"
                        :navigationEnabled="true"
                        :paginationEnabled="false"
                        :navigationClickTargetSize="20"
                        navigationNextLabel='<i class="el-icon-arrow-right" />'
                        navigationPrevLabel='<i class="el-icon-arrow-left" />'
                        >
                        <slide v-for="(property, index) of hotProperties.data" :key="index" >
                            <SearchResultListingCard :property="property" :loading="loading" />
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchBar from '../../_partials/SearchBar';
    import SearchAdvancedNav from '../../_partials/SearchAdvancedNav';
    import SearchResultListingCard from '../../SearchResults/SearchResultListingCard'
    import utilsService from '../../../services/utilsService';
    import { Carousel, Slide } from 'vue-carousel';
    import { mapState } from 'vuex'
    import _ from 'lodash';

    export default {
        name: 'app',
        components: {
            SearchBar,
            SearchAdvancedNav,
            SearchResultListingCard,
            Carousel,
            Slide
        },
        created() {
            this.fetchHotProperties()
        },
        computed: {
            ...mapState({
                sliders: (state) => {
                    return state.general.sliders
                },
                language: (state) => {
                    return state.general.language
                }
            }),
        },
        data: function() {
            return {
                title: 'Home',
                currentPage: 1,
                loading: false,
                hotProperties: {},
                perPage: [[1, 1], [768, 2], [1024, 3]],
                japanese:'"Hiragino Kaku Gothic Pro", "ＭＳ Ｐゴシック"',
                english: "'Bitter', serif"
            }
        },
        head: {
            title: function() {
                return {
                    inner: this.title
                }
            },
            meta: [
                { name: 'title', content: 'Japan Home Finder' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        },
        methods:{
            fetchHotProperties() {
                  const params = {
                      page: this.currentPage,
                  }
                  this.loading = true
                  const promise = this.$store.dispatch('property/hotProperties', params)
                  promise
                  .then((resp) => {
                      this.hotProperties = resp
                      _.forEach(this.hotProperties.data,function(property){
                            property.covers = property.building && property.building.images.length > 0 ? _.union(property.building.images,property.images) : ( property.images.length > 0 ? property.images : utilsService.defaultCover())
                        })
                  })
                  .finally(() => {
                      this.loading = false
                  })


            }
        }
    }
</script>

<style lang="scss">
    .HomePage {
        #rental-procedure {
            padding-top: 1em;

            h1 {
                text-align: center;
            }

            .col {
                text-align: center;
                margin: .5em 0;

                .col-cell {
                    padding: 1em;
                    background: $white;
                    border-radius: 4px;
                    height: 100%;
                    -webkit-box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.05);
                    -moz-box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.05);
                    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.05);
                }

                img {
                    width: 100px;
                    margin-bottom: 1em;
                }

                h3 {
                    margin-top: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    span {
                        color: rgba($primary-color, .8);
                        background: rgba($alternate-color, .05);
                        border-radius: 35px;
                        width: 35px;
                        height: 35px;
                        line-height: 35px;
                        font-size: .7em;
                        margin-right: .5em;
                    }
                }

                p {
                    font-size: 1.1em;
                    line-height: 1.4em;
                    margin-bottom: 0;
                }
            }

        }

        #assess-section {
            margin-top: 3em;
            padding: 2em 0;
            text-align: center;
            background: $primary-color;

            h1 {
                color: $white;
                margin: 0;
            }

            p {
                color: rgba($white, .8);
                font-weight: 600;
                line-height: 1.1em;
                margin-top: .5em;
            }

            button {
                &:hover, &:focus {
                    background-color: $white !important;
                    color: $primary-color !important;
                    -webkit-box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.1);
                    -moz-box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.1);
                    box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.1);
                }
            }
        }

        #video-section {
            padding-top: 1em;

            h1 {
                font-size: 1.5em;
                text-align: left;
            }

            b {
                font-size: 1.5em;
                color: $primary-color;
            }

            .heading {
                display: flex;
                justify-content: space-between;
                align-items: center;

                div {
                    flex: 0 0 350px;
                }

                img {
                    width: 350px;
                }
            }
        }

        #hot-properties {
            padding: 1em 0 3em 0;

            .VueCarousel-slide {
                padding: 0 1em;
            }

            .VueCarousel-navigation-button {
                &:focus {
                    outline: none;
                }
            }

            .VueCarousel-navigation-prev {
                font-size: 2em;
                padding: 0 !important;
            }

            .VueCarousel-navigation-next {
                font-size: 2em;
                padding: 0 !important;
            }
        }

        @media (max-width: 767px) {
            #rental-procedure {
                .col {
                    img {
                        width: 70px;
                        margin-bottom: 1em;
                    }
                }
            }
            #hot-properties {
                .container {
                    padding: 0 2.5rem;
                }

                .VueCarousel-slide {
                    padding: 0 .5em;
                }

                .el-carousel__container {
                    height: 200px;
                }
            }
            #video-section {
                .heading {
                    flex-direction: column;

                    h1 {
                        text-align: center;
                        margin-bottom: .5em;
                    }

                    div {
                        flex: 0 0 100%;
                    }

                    img {
                        width: 250px;
                        margin-bottom: .75em;
                    }
                }
            }
        }
    }

    .Home {
        padding: 0;
        margin: 0;
        // font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #424242;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: calc(100vh - 74px);

        .carousel {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        .el-carousel__container {
            height: 100%;

            .el-carousel__item {
                opacity: 0;
                transform: none !important;
                transition: opacity 2s ease-in-out !important;

                &.is-active {
                    opacity: 1;
                }
            }

            .slider-img {
                width: 100%;
                height: 100%;
                background-position: center center;
                background-size: cover;
            }
        }

        &__TaglineContainer {
            background: rgba(0, 0, 0, 0.25);
            text-align: center;
            align-self: center;
            width: 100%;
            padding: 2em;
            max-width: 750px;
            border-radius: 5px;
            z-index: 5;
        }

        &__Tagline {
            color: white;
        }

        &__TaglineH1 {
            // font-family: 'Bitter', serif;
            font-size: 48px;
            margin-bottom: 0.25em;
            margin-top: 0;
            text-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
        }

        &__TaglineP {
            font-weight: 700;
            font-size: 1.25rem;
            margin: 0 0 2rem 0;
            text-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
        }

        @media (max-width: 767px) {
            height: calc(100vh - 107px);

            .container {
                padding-top: 107px;
            }
        }

        @media (max-width: 600px) {
            &__TaglineH1 {
                font-size: 27px;
            }

            &__TaglineP {
                font-weight: 400;
                font-size: 1rem;
                margin: 0 0 1rem 0;
                line-height: 1.5rem;
            }
        }
    }
</style>
